import * as React from "react";
import { Context } from "./_context";
export const CategoryFurnitureIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3.5 16.5h17V9h2v8.5a1 1 0 0 1-1 1H20v3h-2v-3H6v3H4v-3H2.5a1 1 0 0 1-1-1V9h2v7.5ZM15 3a4 4 0 0 1 4 4v7a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7a4 4 0 0 1 4-4h6ZM9 5a2 2 0 0 0-2 2v6h10V7a2 2 0 0 0-2-2H9Z", fill: "currentColor" }));
  return iconset[size];
};
CategoryFurnitureIcon.iconId = "ZqNTv0";
